import { addItemToCollection } from "directus/src/operations";

export async function createTestimonial({ item }) {
  try {
    const data = await addItemToCollection("testimonials", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
